import Component from 'flarum/common/Component';
export default class BrandMark extends Component {
  view() {
    return m("span", {
      className: "NtBrandMark",
      "aria-hidden": "true"
    }, m("svg", {
      viewBox: "0 0 64 74",
      role: "img"
    }, m("path", {
      d: "M32 2 59 14v31L32 72 5 45V14Z",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "4"
    }), m("path", {
      d: "M11 52V21h7l10 17V21h7v31h-7L18 35v17Z",
      fill: "currentColor"
    }), m("path", {
      d: "M37 21h17v7h-5v24h-8V28h-4Z",
      fill: "currentColor"
    })));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/BrandMark', BrandMark);